import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import styled from 'styled-components';

export const FormWrapper = styled.div`
  margin: 12px 0 24px 0;
`;

export const FieldlWrapper = styled.div`
  text-align: left;

  span {
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #8b9499;
    display: block;
    margin-bottom: 8px;
  }

  input {
    height: 40px;
    line-height: 40px;
  }

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const SubmitButton = styled(ButtonLoader)`
  height: 50px;
  line-height: 48px;
  font-size: 16px;
  text-align: center;
  margin: 0;
  min-width: 199px;
  color: #fff;
`;
